export const EXPERIMENTS_VALUES = {
    AUTOPAY_PHASE_2: {
        CONSENT: "CONSENT",
        SUBTLE_AUTOPLACE: "SUBTLE_AUTOPLACE",
    },
    PAYMENT_ABANDONMENT_FEEDBACK: "payment_abandonment_feedback",
    ENABLE_UPI_INTENT_CANCEL: "upiIntentShowCancel",
};
